import { CincClientType } from "../enums/CincClientType";
import { Company } from "../enums/Company";
import { ConsumerPropertyListing } from "./ConsumerPropertyListing";

export class FormCreationRequest{
    public DomainName!: string;
    public ClientFullName!: string;
    public Niche! : string;
    public Link!: string;
    public FavoriteCity!: string;
    public SavedSearch!: string;
    public Location!: string;
    public Source!: string;
    public PageId! : string;
    public Company!: Company;
    public CampaignType!: string;
    public CincClientType!: CincClientType;
    public AssociatedPropertyListing!: ConsumerPropertyListing;
}

export class CreatorInfoCreationRequest{
    public AdAccountId!: string;
    public Company!: Number;
    public MissingProperties!: CreatorInfoMissingProperty[];
}

export class CreatorInfoMissingProperty{
    public ObjectType!: string;
    public ObjectId!: string;
    public PropertyName!: string;
    public Value!: string;
}